import { UnitSevenStatusEnum } from "../../Enum/status.enum"
import { TrimCardStatusEnum, WfxCarharttEnum } from "../../Enum/wfx.enum"

export class TrimCards {
    id: number
    styleData: string
    seasonData: string
    styleDescription: string
    submitDate: string
    techPack: string
    stateData: string
    factory: string
    approvalType: string
    factoryMerchandiserSign: string
    comments: string
    approvedBy: string
    createdAt: string
    dropDown: string
    filePath: string
    fileName: string;
    originalname: string;
    imageFiles: string;
    imageOriginalName: string;
    status: TrimCardStatusEnum
    combinedProductPlusColor: {
        combinedFabricColorHeaders: MeasurementDataReq[];
        combinedLabelColorHeaders: MeasurementDataReq[];
        combinedPackingColorHeaders: MeasurementDataReq[];
        combinedTrimColorHeaders: MeasurementDataReq[];
    };
    combinedColumbiaPlusColor: {
        combinedColumbiaFabricHeaders: MeasurementDataReq[];
        combinedColumbiaSewingHeaders: MeasurementDataReq[];
        combinedColumbiaPackingHeaders: MeasurementDataReq[];
        combinedColumbiaEmbellishmentHeaders: MeasurementDataReq[];
    };

    combinedCKPlusColor: {
        combinedCKFabricAndLiningColorHeaders: MeasurementDataReq[];
        combinedCKZippersColorHeaders: MeasurementDataReq[];
        combinedCKTrimsColorHeaders: MeasurementDataReq[];
    };

    constructor(
        id: number,
        styleData: string,
        seasonData: string,
        styleDescription: string,
        submitDate: string,
        techPack: string,
        stateData: string,
        factory: string,
        approvalType: string,
        factoryMerchandiserSign: string,
        comments: string,
        approvedBy: string,
        createdAt: string,
        dropDown: string,
        filePath: string,
        fileName: string,
        originalname: string,
        imageFiles: string,
        imageOriginalName: string,
        status: TrimCardStatusEnum,
        combinedProductPlusColor: {
            combinedFabricColorHeaders: MeasurementDataReq[];
            combinedLabelColorHeaders: MeasurementDataReq[];
            combinedPackingColorHeaders: MeasurementDataReq[];
            combinedTrimColorHeaders: MeasurementDataReq[];
        },
        combinedColumbiaPlusColor: {
            combinedColumbiaFabricHeaders: MeasurementDataReq[];
            combinedColumbiaSewingHeaders: MeasurementDataReq[];
            combinedColumbiaPackingHeaders: MeasurementDataReq[];
            combinedColumbiaEmbellishmentHeaders: MeasurementDataReq[];
        },
        combinedCKPlusColor: {
            combinedCKFabricAndLiningColorHeaders: MeasurementDataReq[];
            combinedCKZippersColorHeaders: MeasurementDataReq[];
            combinedCKTrimsColorHeaders: MeasurementDataReq[];
        }
    ) {
        this.id = id
        this.styleData = styleData
        this.seasonData = seasonData
        this.styleDescription = styleDescription
        this.submitDate = submitDate
        this.techPack = techPack
        this.stateData = stateData
        this.factory = factory
        this.approvalType = approvalType
        this.factoryMerchandiserSign = factoryMerchandiserSign
        this.comments = comments
        this.approvedBy = approvedBy
        this.createdAt = createdAt
        this.dropDown = dropDown
        this.status = status
        this.combinedProductPlusColor = combinedProductPlusColor
        this.combinedColumbiaPlusColor = combinedColumbiaPlusColor
        this.combinedCKPlusColor = combinedCKPlusColor
        this.filePath = filePath
        this.fileName = fileName
        this.originalname = originalname
        this.imageFiles = imageFiles
        this.imageOriginalName = imageOriginalName
    }
}



export class MeasurementDataReq {
    id?: number;
    styleId?: number;
    measurement?: string;
    status?: UnitSevenStatusEnum;
    color?: string;
    shade?: string;
    constructor(
        id: number,
        styleId: number,
        measurement: string,
        status?: UnitSevenStatusEnum,
        color?: string,
        shade?: string
    ) {
        this.id = id;
        this.styleId = styleId;
        this.measurement = measurement;
        this.status = status
        this.color = color
        this.shade = shade
    }

}

export class MeasurementDataCardDeleteReq {
    id?: number;
    constructor(
        id: number,
    ) {
        this.id = id;
    }
}

export class BuyerStatusReq {
    id?: number;
    status?: UnitSevenStatusEnum
    constructor(
        id: number,
        status?: UnitSevenStatusEnum
    ) {
        this.id = id;
        this.status = status
    }
}



export class MeasurementDataTrimCardReq {
    id?: number;
    styleId?: number;
    measurementData?: string;
    trimCard?: WfxCarharttEnum;
    constructor(
        id?: number,
        styleId?: number,
        measurementData?: string,
        trimCard?: WfxCarharttEnum,
    ) {
        this.id = id;
        this.styleId = styleId;
        this.measurementData = measurementData;
        this.trimCard = trimCard
    }

}


export class CkMeasurementDataThreadsReq {
    id?: number;
    shade?: string;
    constructor(
        id?: number,
        shade?: string
    ) {
        this.id = id;
        this.shade = shade;
    }
}

export class CKMeasurementLabelHangtagReq {
    id?: number;
    styleId?: number;
    measurement?: string;
    constructor(
        id?: number,
        styleId?: number,
        measurement?: string
    ) {
        this.id = id;
        this.styleId = styleId;
        this.measurement = measurement;
    }
}

export class CKMeasurementStatusDeleteBlockReq {
    id?: number;
    styleId?: number;
    status?: TrimCardStatusEnum;
    constructor(
        id?: number,
        styleId?: number,
        status?: TrimCardStatusEnum
    ) {
        this.id = id;
        this.styleId = styleId;
        this.status = status;
    }
}